export default __webpack_public_path__ + "static/media/noteTaker-sq.f1c9cb7d.jpg";